import { useEffect, useState } from 'react';
import { apiUrl } from '../../../api/apiUrl';
import http from '../../../api/axios';
import DataTable from '../../../components/table/DataTable';
import { useParams } from 'react-router-dom';
import { useCurrentCompany } from '../../../hooks/useCompany';
import { columns } from '../../../components/columns/Company/UserTaskHistoryColumns';
import { UserTaskHistory } from '../../../types/UserTaskHistory';

/**
 * Component represents user tasks history overview
 */
export const UserTaskHistoryPage = () => {
  const { id: taskId } = useParams();
  const [data, setData] = useState<UserTaskHistory[] | null>(null);
  const { company } = useCurrentCompany();

  /**
   * Loads user tasks
   */
  const fetchData = async () => {
    if (!company) return;
    const response = await http.apiGet({
      url: `${apiUrl.USER_TASK_HISTORY_LIST}?parentId=${taskId}`,
    });
    setData(response?.data);
  };

  useEffect(() => {
    fetchData();
  }, [company]);

  return <DataTable data={data} columns={columns} />;
};
